define('app/routers/location_page_router',['app/setup'], function(takhfifan) {
  var LocationPageRoute = Backbone.Router.extend({
    routes: {
      "*category": "filterCategory"
    },

    filterCategory: function (category) {
      var categoryId = -1;
      if(!(_.isNull(category) || _.isUndefined(category))){
        categoryId = category.split("-")[0];
        if(_.isNaN(parseInt(categoryId,10))){categoryId=-1}
      }
      takhfifan.eventHub.trigger('location:categoryChanged', categoryId);
    }

  });

  //detect page and add routes (instead of using factory)
  if($('.location-page-wrapper').length){
    takhfifan.locationPageRouter =  new LocationPageRoute;
  }
});

